export default __webpack_public_path__ + "8aca6ea37dc6fe3b0ff7311bc50e380f.jpg";